import { IColumn, TDataItem } from '../../types';
import { TableContainer } from 'assets/css/ui-kit/table';

interface IProps<T> {
	columns: IColumn[];
	data: T[];
	loading?: boolean;
}

const Table = <T,>({ columns, data, loading }: IProps<T>) => {
	return (
		<section>
			<TableContainer>
				<table>
					<thead>
						<tr>
							<th />
							{columns.map(column => (
								<th key={column.id}>{column.name}</th>
							))}
							<th />
						</tr>
					</thead>
					<tbody>
						{data.map((item: TDataItem, index: number) => (
							<tr key={index}>
								<td />
								{columns.map((column, index) => (
									<td key={column.id} className={column.id === 6 ? 'center' : ''}>
										{column.render(item, index)}
									</td>
								))}
								<td />
							</tr>
						))}
					</tbody>
				</table>
			</TableContainer>

			{/* No Data  */}
			{data.length === 0 && (
				<div className='no-data'>
					<span>No Data to Display</span>
				</div>
			)}
		</section>
	);
};

export default Table;
